import React from "react";
import GeneralTranslations from "../../../Common/ModuleTranslations/es";
import BookableTranslations from "../../Bookable/ModuleTranslations/es";
import {
  RATE_TYPE,
  RESTRICTION_TYPE,
  DEVICE_TYPE,
  CODE_TYPE,
  SHARING_TYPE,
  RESTRICTION_VALUE_TYPE,
} from "../../../Common/constants";
import { removeIconSetIdentifier } from "../ModuleDefinition";
import { getTranslatedCountryList } from "../../../../../lib/intlUtils";

const customBookableTranslations = BookableTranslations.fields.form.map(field => {
  if (field.fieldName === "isVisible") {
    field.displayName = "Visible en el frontal de reservas";
  }
  return field;
});

export default {
  locale: "es",
  name: "Promociones",
  filterFields: [
    ["isActive", "bool"],
    ["isVisible", "bool"],
    "ticker",
    "name",
    [
      "promotionType",
      "selector",
      [
        { label: "Descuento % ", value: RATE_TYPE.PERCENTAGE },
        { label: "Destacado", value: RATE_TYPE.HIGHLIGHT_MESSAGE },
        { label: "Dto. fijo/día", value: RESTRICTION_VALUE_TYPE.MONEY },
        { label: "Regalar noche/s (ej. 3x2)", value: RATE_TYPE.GIVE_NIGHT },
      ],
    ],
    [
      "group",
      "selector",
      [
        { label: "Uno", value: "1" },
        { label: "Dos", value: "2" },
        { label: "Tres", value: "3" },
        { label: "Cuatro", value: "4" },
        { label: "Cinco", value: "5" },
        { label: "Seis", value: "6" },
        { label: "Siete", value: "7" },
        { label: "Ocho", value: "8" },
        { label: "Nueve", value: "9" },
        { label: "Diez", value: "10" },
      ],
    ],
    "CODE",
    [
      "sharingType",
      "selector",
      [
        { label: "-", value: SHARING_TYPE.SIMPLE },
        { label: "Compartida", value: SHARING_TYPE.SHARED },
      ],
    ],
  ],
  translation: { displayName: "Traducciones" },
  tabs: [
    {
      title: {
        create: "Configuración",
        edit: "Edición",
      },
    },
    {
      title: "Código de uso único",
    },
  ],
  fields: {
    list: [
      {
        fieldName: "ticker",
        displayName: "Id",
      },
      ...BookableTranslations.fields.list,
      {
        fieldName: "promotionType",
        displayName: "Tipologia",
      },
      {
        fieldName: "sharingType",
        displayName: "Uso",
      },
      {
        fieldName: "group",
        displayName: "Grupo",
        tooltip: "Acumulación de promociones",
      },
      {
        fieldName: `${RESTRICTION_TYPE.OPEN_TRAVEL}_value`,
        displayName: "Validez (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.CLOSE_TRAVEL}_value`,
        displayName: "Bloqueos (travel w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.OPEN_BOOKING}_value`,
        displayName: "Contratable (booking w)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MIN_STAY}_duration`,
        displayName: "Est. min. (noches)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MAX_STAY}_duration`,
        displayName: "Est. max. (noches)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MIN_NOTICE}_duration`,
        displayName: "Ant. Min. (d) (Release)",
      },
      {
        fieldName: `${RESTRICTION_TYPE.MAX_NOTICE}_duration`,
        displayName: "Ant. max. (d) (Release)",
      },
      {
        fieldName: RESTRICTION_TYPE.CODE,
        displayName: "Códigos",
      },
      {
        fieldName: "type",
        displayName: "Tipo",
      },
    ],
    form: [
      {
        fieldName: "infoMessageChainPromo",
        value: "Los cambios se aplicarán en todos los motores seleccionados",
      },
      ...GeneralTranslations.fields.form,
      ...customBookableTranslations,
      {
        fieldName: "rateTypeSection",
        displayName: "Tipología",
      },
      {
        fieldName: "rateType",
        options: [
          {
            ticker: RATE_TYPE.PERCENTAGE,
            name: "Descuento %",
          },
          {
            ticker: RATE_TYPE.CONSTANT,
            name: "Dto. fijo/dia",
          },
          {
            ticker: RATE_TYPE.GIVE_NIGHT,
            name: "Regalar noche/s (ej. 3x2)",
          },
          {
            ticker: RATE_TYPE.HIGHLIGHT_MESSAGE,
            name: "Mensaje destacado",
          },
        ],
      },
      {
        fieldName: "group",
        displayName: "Grupo",
      },
      {
        fieldName: "ratePercentage",
        displayName: "Cantidad",
        helpText:
          "Porcentaje de descuento que se aplicará al precio de alojamiento sujeto a la promoción",
      },
      {
        fieldName: "rateConstant",
        displayName: "Cantidad",
        helpText:
          "Descuento fijo por día que se aplicará al precio del alojamiento sujeto a la promoción",
      },
      {
        fieldName: RESTRICTION_TYPE.CLOSE_TRAVEL,
        displayName: "Bloqueo",
        description:
          "Permitir deshabilitar la promoción para fechas determinadas en la sección Inventario > Gestión",
      },
      {
        fieldName: "accumulationPromotions",
        openContainerText: "Ver acumulación de promociones",
        closeContainerText: "Ocultar acumulación de promociones",
      },
      {
        fieldName: "accumulationPromotionsSection",
        displayName: "Acumulación de promociones",
        subtitle:
          "Sólo se acumularán promos que pertenezcan a grupos diferentes, si existen varias promos aplicables de un mismo grupo, se elige aquella que tenga el mayor beneficio.",
      },
      {
        fieldName: "stayDatesSection",
        displayName: "Fechas de estancia (travel window)",
      },
      {
        fieldName: RESTRICTION_TYPE.OPEN_TRAVEL_START_DATE,
        displayName: "Fecha inicio",
        placeholder: "Introduce una fecha",
      },
      {
        fieldName: RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE,
        displayName: "Fecha fin",
        placeholder: "Introduce una fecha",
      },
      {
        fieldName: "codeType",
        optionDisplay: {
          [CODE_TYPE.NO_CODE]: {
            label: "Sin código",
          },
          [CODE_TYPE.UNIVERSAL_CODE]: {
            label: "Código universal",
          },
        },
      },
      {
        fieldName: "showPopup",
        displayName: "Mostrar pop up con descripción de promociones",
      },
      {
        fieldName: "restrictionsSection",
        displayName: "Restricciones",
      },
      {
        fieldName: RESTRICTION_TYPE.MIN_STAY,
        description: "Estancia mínima (noches)",
      },
      {
        fieldName: RESTRICTION_TYPE.MAX_STAY,
        description: "Estancia máxima (noches)",
      },
      {
        fieldName: RESTRICTION_TYPE.MIN_NOTICE,
        description: "Antelación mínima (días)",
      },
      {
        fieldName: RESTRICTION_TYPE.MAX_NOTICE,
        description: "Antelación máxima (días)",
      },
      {
        fieldName: "deviceSection",
        displayName: "Dispositivos habilitados",
        subtitle:
          "Esta promoción se aplicará a los usuarios conectados desde los dispositivos escogidos.",
      },
      {
        fieldName: RESTRICTION_TYPE.DEVICE_TYPE,
        displayName: "",
        options: [
          {
            ticker: DEVICE_TYPE.DESKTOP,
            name: "Desktop",
          },
          {
            ticker: DEVICE_TYPE.TABLET,
            name: "Tablet",
          },
          {
            ticker: DEVICE_TYPE.MOBILE,
            name: "Móvil",
          },
        ],
      },
      {
        fieldName: "geoLocationSection",
        displayName: "Geolocalización",
        widget: "section",
        subtitle:
          "Esta promoción sólo se aplicará a los usuarios conectados desde IP's de los paises incluidos",
      },
      {
        fieldName: RESTRICTION_TYPE.GEOLOCATION,
        options: getTranslatedCountryList("es"),
        leftListHeader: "Países incluidos",
        rightListHeader: "Países excluidos",
      },
      {
        fieldName: "sharingType",
        displayName: "Uso",
        optionDisplay: {
          [SHARING_TYPE.SIMPLE]: {
            label: "Sólo se muestra en el agregador",
          },
          [SHARING_TYPE.SHARED]: {
            label: "Compartida",
          },
        },
      },
      {
        fieldName: "appliesToInventoriesSection",
        displayName: "Líneas de inventario",
        subtitle: "Esta promoción sólo se aplicará a las líneas inventario escogidas",
      },
      {
        fieldName: "appliesToInventories",
        filterNames: ["Alojamiento", "Condiciones", "Configuraciones", "Pensiones"],
      },
      {
        fieldName: "icon",
        displayName: "Icono",
        placeholder: "Sin icono",
        optionLabelRenderer: ({ value, name }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ fontSize: 6, marginRight: "5px" }}>
              <i className="material-icons">{removeIconSetIdentifier(value)}</i>
            </span>
            <span style={{ fontSize: 14 }}>{name}</span>
          </div>
        ),
      },
      {
        fieldName: "infoMessage",
        value:
          "Para activar códigos de un solo uso debes guardar una promoción primero y acceder de nuevo para editar.",
      },
      {
        displayName: "Fechas/horario de contratación (booking window)",
        widget: "section",
        fieldName: "bookingWindowSection",
      },
      {
        fieldName: "bookingWindow",
        nestedTitle: "Fechas/horario de contratación (booking window)",
      },
    ],
  },
  validation: {
    [RESTRICTION_TYPE.OPEN_TRAVEL_START_DATE]: {
      constraints: {
        compare: {
          message: "^La fecha fin debe ser mayor que la fecha inicio.",
        },
      },
    },
    [RESTRICTION_TYPE.OPEN_TRAVEL_END_DATE]: {
      constraints: {
        compare: {
          message: "^La fecha fin debe ser mayor que la fecha inicio y mayor que hoy.",
        },
      },
    },
  },
};
